module.exports = __webpack_public_path__ + "img/pwd.99db1dea.png";